import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./logosimple.png";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import { useLanguage } from "./idiomas";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, } = useLanguage();

  const handleLinkClick = () => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  };

  // Textos según idioma
  const texts = {
  es: {
    home: "Inicio",
    services: "Áreas de Servicio",
    team: "Equipo",
    contact: "Contacto",

  },
  en: {
    home: "Home",
    services: "Practice Areas",
    team: "Team",
    contact: "Contact",
  },
  fr: {
    home: "Accueil",
    services: "Domaines d’activité",
    team: "Équipe",
    contact: "Contact",

  },
};

  const t = texts[language];

  return (
    <nav className="sticky top-0 z-50 bg-white/50 backdrop-blur-md shadow-sm px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-3 no-underline"
          onClick={handleLinkClick}
        >
          <img
            src={logo}
            alt="Logo Bufete AltaMar"
            className="w-20 h-20 object-contain"
          />
          <div>
            <div className="font-bold text-lg">Legal Innova</div>
            <div className="text-sm text-[#1E2E45]/80">
              {language === "es" ? "Asesoría legal" : "Legal Consulting"}
            </div>
          </div>
        </Link>

        {/* Botón de menú hamburguesa */}
        <button
          className="sm:hidden text-3xl text-[#1E2E45]"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          {menuOpen ? <HiOutlineX /> : <HiOutlineMenu />}
        </button>

        {/* Navegación escritorio */}
        <div className="hidden sm:flex items-center gap-4">
          <Link
            to="/"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.home}
          </Link>
          <Link
            to="/services"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.services}
          </Link>
          <Link
            to="/team"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.team}
          </Link>
          <Link
            to="/contact"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.contact}
          </Link>
        
        </div>
      </div>

      {/* Menú móvil */}
      {menuOpen && (
        <div className="flex flex-col gap-3 mt-4 sm:hidden">
          <Link
            to="/"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.home}
          </Link>
          <Link
            to="/services"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.services}
          </Link>
          <Link
            to="/team"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.team}
          </Link>
          <Link
            to="/contact"
            className="px-4 py-2 rounded-lg hover:bg-[#1E2E45]/10 transition"
            onClick={handleLinkClick}
          >
            {t.contact}
          </Link>

        </div>
      )}
    </nav>
  );
}
